import { t } from '@/i18n';
import { BackendBaseModel, type booleanStringType } from '@/utils';
import { z } from 'zod';

/// ////////////////////////////////////////////
/// Enum
/// ////////////////////////////////////////////

export const permissionType = z.enum([
  'none',
  'view',
  'edit',
  'privilege',
  'view-all-privilege',
]);
export const PermissionTypeLabelModifier = {
  none: t('permission-none'),
  view: t('permission-view'),
  edit: t('permission-edit'),
  privilege: t('permission-privilege'),
  'view-all-privilege': t('view-all-privilege'),
} as const satisfies Record<z.infer<typeof permissionType>, string>;

export const AbilityLabelModifier = {
  false: t('permission-none'),
  true: t('permission-authorized'),
} as const satisfies Record<z.infer<typeof booleanStringType>, string>;

/// ////////////////////////////////////////////
/// Model
/// ////////////////////////////////////////////

const ResourceGroupPermissionsModel = z.object({
  project: permissionType,
  indicator: permissionType,
  localTag: permissionType,
  globalTag: permissionType,
  masterTable: permissionType,
  administrator: permissionType,
});

export const RoleBaseModel = z.object({
  templateAbility: z.boolean(),
  lockAbility: z.boolean(),
  publishAbility: z.boolean(),
  continueAbility: z.boolean(),
  resourceGroupPermissions: ResourceGroupPermissionsModel,
});

export const RoleModel = BackendBaseModel.merge(RoleBaseModel).extend({
  name: z.string(),
});

export const RolesModel = RoleModel.array();

/// ////////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////////

export const RoleFormSchema = RoleBaseModel.extend({
  name: z.string().min(1),
});

export const BulkRoleFormSchema = z.object({
  code: z.string().nullish(),
  roleId: z.string().uuid().nullish(),
  organizationName: z.string().nullish(),
  organizationIds: z.string().uuid().array().min(1),
});

export const BulkRoleMutationParamsSchema = BulkRoleFormSchema.pick({
  organizationIds: true,
}).extend({
  id: z.string().uuid(),
});
